import { render, staticRenderFns } from "./createnotice.vue?vue&type=template&id=45a679a1&"
import script from "./createnotice.vue?vue&type=script&lang=ts&"
export * from "./createnotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createnotice.vue"
export default component.exports